import React from 'react';
import { Spread } from '../../types/spread';

interface TarotTherapyBannerProps {
  spread: Spread;
  columnClassName: string;
}

const TarotTherapyBanner: React.FC<TarotTherapyBannerProps> = ({ spread, columnClassName }) => (
  <div className={columnClassName}>
    <div className="therapy-banner shadow-lg h-100" style={{ borderRadius: '1rem', overflow: 'hidden' }}>
      <div className="d-flex flex-column flex-xl-row h-100 align-items-center gap-0 p-0">

        {/* Main content */}
        <div className="flex-grow-1 p-4 p-xl-5 text-center text-xl-start">
          <span
            className="d-inline-flex align-items-center gap-2 mb-3"
            style={{
              background: 'rgba(255,255,255,0.12)',
              borderRadius: 999,
              padding: '0.3em 0.9em',
              fontSize: '0.72rem',
              letterSpacing: '0.13em',
              textTransform: 'uppercase',
              fontWeight: 700,
              color: 'rgba(255,255,255,0.9)',
              whiteSpace: 'nowrap',
            }}
          >
            <span className="live-dot" />
            Живо видео
          </span>

          <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-xl-start gap-2 mb-2">
            <h3
              className="fw-bold m-0"
              style={{ fontSize: 'clamp(1.6rem, 3vw, 2.2rem)', color: '#fff', letterSpacing: '-0.01em' }}
            >
              {spread.title}
            </h3>
            {spread.durationLabel && (
              <span
                style={{
                  border: '1px solid rgba(255,255,255,0.35)',
                  borderRadius: 999,
                  padding: '0.2em 0.75em',
                  fontSize: '0.75rem',
                  fontWeight: 700,
                  color: 'rgba(255,255,255,0.85)',
                  whiteSpace: 'nowrap',
                }}
              >
                {spread.durationLabel}
              </span>
            )}
          </div>
          <p className="mb-0 mx-auto mx-xl-0" style={{ opacity: 0.65, maxWidth: 480, lineHeight: 1.6 }}>
            {spread.orderDescription}
          </p>
        </div>

        {/* Divider */}
        <div
          className="d-none d-xl-block flex-shrink-0"
          style={{ width: 1, alignSelf: 'stretch', background: 'rgba(255,255,255,0.12)' }}
        />

        {/* Price + CTA */}
        <div
          className="d-flex flex-column align-items-center justify-content-center gap-3 flex-shrink-0 p-4 p-xl-5"
          style={{ minWidth: 200 }}
        >
          <div className="text-center">
            <div style={{ fontSize: 'clamp(2.4rem, 4vw, 3rem)', fontWeight: 900, lineHeight: 1, color: '#fff' }}>
              {spread.price} EUR
            </div>
          </div>

          <a
            className="btn fw-bold w-100 d-flex align-items-center justify-content-center gap-2"
            role="button"
            href={spread.button.href}
            style={{
              background: '#fff',
              color: '#474444',
              border: 'none',
              padding: '0.65rem 1.5rem',
              borderRadius: '0.5rem',
              fontSize: '0.95rem',
            }}
          >
            {spread.button.text}
          </a>
        </div>

      </div>
    </div>
  </div>
);

export default TarotTherapyBanner;
